<template>
	<div>
		<loading-modal v-if="isLoadingPerformanceReview" loading-text="Loading Performance Review..." />

		<performance-review-editor v-else
			:employees="employees"
			:logged-in-employee="loggedInEmployee"
			:performance-review="performanceReview"
			:default-discussion-points="defaultDiscussionPoints"
			:core-values="coreValues"
			:meeting-locations="meetingLocations"
			:templates="templates"
			:is-saving="isSaving"
			@save="onSave"
			@cancel="onCancel"
		></performance-review-editor>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import PerformanceReviewEditor from '@/components/performanceReview/PerformanceReviewEditor';
	import LoadingModal from '@/components/LoadingModal';

	export default {
		name: 'PagePerformanceReviewEdit',
		props: {
			id: {
				required: true
			}
		},
		data() {
			return {
				isSaving: false,
				performanceReview: null,
				isLoadingPerformanceReview: false
			}
		},
		components: {
			PerformanceReviewEditor,
			LoadingModal
		},
		computed: {
			...mapGetters({
				employees: 'employees/employeesMiniActiveOnly',
				defaultDiscussionPoints: 'defaultDiscussionPoints/defaultDiscussionPoints',
				coreValues: 'coreValues/coreValues',
				loggedInEmployee: 'loggedInEmployee',
				meetingLocations: 'meetingLocations/meetingLocations',
				templates: 'performanceReviewTemplates/templates'
			}),
		},
		methods: {
			onSave(performanceReview) {
				this.isSaving = true;
				this.$store.dispatch('performanceReview/edit', performanceReview).then(
					data => {
						this.isSaving = false;
						this.$router.push(`/pr/${data.id}`);
					},
					error => {
						this.isSaving = false;
						console.error('Error saving performance review');
					}
				);
			},
			onCancel() {
				window.history.back();
			}
		},
		async created() {
			this.$store.dispatch('setPageTitle', "Edit Performance Review");

			this.isLoadingPerformanceReview = true;
			try {
				this.performanceReview = await this.$store.dispatch('performanceReviews/getById', this.id);
			} catch(err) {
				
			} finally {
				this.isLoadingPerformanceReview = false;
			}
		},
	};
</script>

<style></style>
